import {SplitViewGrid, gridCols} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

export const ArticleDetailSplitViewGrid = styled(SplitViewGrid)`
  margin-bottom: 12vh;
`;

export const ImageSectionWrapper = styled.section`
  position: relative;
  padding-top: 24px;
  ${gridCols(6)}
`;

// Used to set a space on the top of the buy box and don't
// mess with the alignment of the sticky component
export const BuyboxTopSpacer = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
`;

export const breadcrumbsStyles = `
  margin: 24px 0 0;
`;
